import { JobNotificationCardModel } from '../job-notification-card.model';

export class ExportAllNotificationCardModel extends JobNotificationCardModel {}
